import React from "react";
import "../../components/ReportModall.css";
import "../../articlesblogs/FilterBlog.css";
import "./CoinChooseOption.css";
import CoinConverterGif from "../../assets/images/Coin-converter.gif";
// Import SVG

const LogoutModal = ({ open, onClose, onStoreClick, onHistoryClick }) => {
  if (!open) return null;

  const closeAll = () => {
    onClose();
  };

  return (
    <div
      className="modal-overlay resetModal unlockModal delModal"
      onClick={onClose}
    >
      <div
        className="modal-container text-center rounded-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <div className="close-btn2 text-end unlock-close-btn">
          <button
            type="button"
            className="btn-close"
            onClick={closeAll}
            aria-label="Close"
          >
            {" "}
          </button>
        </div>

        {/* Icon */}
        <div className="premium-icon delete-trash">
          <span>
            <img className="gifCoin" src={CoinConverterGif} alt="" />
          </span>
        </div>

        {/* Title */}
        <h5 className="fw-bold blackText mb-2">Choose an Option below</h5>

        <div className="filter-blog-modal__footer coinButton">
          <button
            type="button"
            className="filter-blog-modal__action delete-close"
            onClick={onHistoryClick}
          >
            <span>Coin History</span>
          </button>
          <button
            type="button"
            className="filter-blog-modal__action filter-blog-modal__action--apply blockDoubt-btn"
            onClick={onStoreClick}
          >
            <span> Coin Store</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
